import React, { useState } from 'react';
import { SimulationReport } from '../../../lib/supabase';

interface PastReportsModalProps {
    reports: SimulationReport[];
    onClose: () => void;
}

export const PastReportsModal: React.FC<PastReportsModalProps> = ({ reports, onClose }) => {
    const [expandedReportId, setExpandedReportId] = useState<string | null>(null);

    return (
        <div className="modal-overlay" style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000
        }}>
            <div className="modal-content" style={{
                background: 'white', width: '800px', maxWidth: '95vw', height: '85vh', borderRadius: '16px',
                display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
            }}>
                <div className="modal-header" style={{
                    padding: '20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                }}>
                    <h2 style={{ margin: 0, fontSize: '20px' }}>Geçmiş Rapor Arşivi</h2>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px' }}>
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                <div className="modal-body" style={{ flex: 1, overflowY: 'auto', padding: '24px', background: '#f9fafb' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {reports.map((report) => {
                            const data = typeof report.report_data === 'string' ? JSON.parse(report.report_data) : report.report_data;
                            const isExpanded = expandedReportId === report.id;

                            return (
                                <div key={report.id} style={{
                                    background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb',
                                    overflow: 'hidden', transition: 'all 0.2s'
                                }}>
                                    <div
                                        onClick={() => setExpandedReportId(isExpanded ? null : report.id)}
                                        style={{
                                            padding: '16px 20px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                            background: isExpanded ? '#f3f4f6' : 'white'
                                        }}
                                    >
                                        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                            <div style={{
                                                width: '40px', height: '40px', borderRadius: '8px', background: (report.score || 0) > 70 ? '#d1fae5' : '#fee2e2',
                                                color: (report.score || 0) > 70 ? '#065f46' : '#991b1b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold'
                                            }}>
                                                {report.score || 0}
                                            </div>
                                            <div>
                                                <div style={{ fontWeight: 600, color: '#1f2937' }}>{report.simulation_title}</div>
                                                <div style={{ fontSize: '12px', color: '#6b7280' }}>{new Date(report.created_at).toLocaleString('tr-TR')}</div>
                                            </div>
                                        </div>
                                        <span className="material-symbols-outlined" style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                            expand_more
                                        </span>
                                    </div>

                                    {isExpanded && (
                                        <div style={{ padding: '20px', borderTop: '1px solid #e5e7eb' }}>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
                                                <div>
                                                    <h4 style={{ fontSize: '13px', color: '#059669', marginBottom: '8px' }}>ARTILAR</h4>
                                                    <ul style={{ fontSize: '13px', color: '#374151', paddingLeft: '16px' }}>
                                                        {data.positives?.map((p: string, i: number) => <li key={i}>{p}</li>)}
                                                    </ul>
                                                </div>
                                                <div>
                                                    <h4 style={{ fontSize: '13px', color: '#dc2626', marginBottom: '8px' }}>EKSİLER</h4>
                                                    <ul style={{ fontSize: '13px', color: '#374151', paddingLeft: '16px' }}>
                                                        {data.negatives?.map((p: string, i: number) => <li key={i}>{p}</li>)}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div>
                                                <h4 style={{ fontSize: '13px', color: '#4f46e5', marginBottom: '8px' }}>ANALİZ</h4>
                                                <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#4b5563' }}>{data.shortAnalysis}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
